import { render } from "./BazaKorisnika.vue?vue&type=template&id=70e270be&scoped=true&lang=html"
import script from "./BazaKorisnika.vue?vue&type=script&lang=js"
export * from "./BazaKorisnika.vue?vue&type=script&lang=js"

import "./BazaKorisnika.vue?vue&type=style&index=0&id=70e270be&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-70e270be"

export default script